import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  applicationSubmissionRequestBody: null,
  applicationSubmissionResponse: null,
  loading: false,
  error: null,
};

const applicationSubmissionSlice = createSlice({
  name: 'applicationSubmission',
  initialState,
  reducers: {
    setApplicationSubmissionRequestBody(state, action) {
      state.applicationSubmissionRequestBody = action.payload;
      state.loading = true;
      state.error = null;
    },
    setApplicationSubmissionResponse(state, action) {
      state.applicationSubmissionResponse = action.payload;
      state.loading = false;
    },
    setApplicationSubmissionError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    clearApplicationSubmissionState(state) {
      state.applicationSubmissionRequestBody = null;
      state.applicationSubmissionResponse = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  setApplicationSubmissionRequestBody,
  setApplicationSubmissionResponse,
  setApplicationSubmissionError,
  clearApplicationSubmissionState,
} = applicationSubmissionSlice.actions;

export default applicationSubmissionSlice.reducer;
